/** Configuração de runtime, vinda de variáveis VITE_* (com defaults para dev local). */
export const config = {
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined) ?? 'http://localhost:4000',
  /** 'dev' = auto-login local; 'cognito' = Hosted UI. */
  authMode: ((import.meta.env.VITE_AUTH_MODE as string | undefined) ?? 'dev') as 'dev' | 'cognito',
  cognito: {
    domain: import.meta.env.VITE_COGNITO_DOMAIN as string | undefined,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined,
    redirectUri:
      (import.meta.env.VITE_COGNITO_REDIRECT as string | undefined) ??
      (typeof window !== 'undefined' ? window.location.origin : ''),
  },
  kioskToken: (import.meta.env.VITE_KIOSK_TOKEN as string | undefined) ?? 'kiosk-dev-token',
};
